var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPowerpoint = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#powerpoint_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ED6C47",
  d: "M22.544 2.5a17.32 17.32 0 0 0-12.25 5.14A17.63 17.63 0 0 0 5.198 20l21.976 4.671z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF8F6B",
  d: "M22.544 2.5c4.597.014 9.001 1.862 12.251 5.14A17.63 17.63 0 0 1 39.89 20l-8.673 5.948L22.544 20z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D35230",
  d: "M22.544 37.5a17.32 17.32 0 0 0 12.251-5.14A17.63 17.63 0 0 0 39.89 20H5.198a17.63 17.63 0 0 0 5.096 12.36 17.32 17.32 0 0 0 12.25 5.14"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M20.892 8.75H9.295a17.5 17.5 0 0 0-4.076 12.105A17.46 17.46 0 0 0 10.447 32.5h10.445a1.65 1.65 0 0 0 1.167-.49c.31-.311.484-.734.485-1.176V10.416a1.68 1.68 0 0 0-.485-1.177 1.65 1.65 0 0 0-1.167-.489",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M19.653 10H8.345A17.5 17.5 0 0 0 5.39 22.588 17.41 17.41 0 0 0 11.87 33.75h7.784a1.65 1.65 0 0 0 1.166-.49c.31-.312.484-.735.485-1.176V11.666a1.68 1.68 0 0 0-.485-1.177A1.65 1.65 0 0 0 19.653 10",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M19.653 10H8.345a17.47 17.47 0 0 0-3.128 10.789A17.45 17.45 0 0 0 9.295 31.25h10.359a1.65 1.65 0 0 0 1.166-.49c.31-.312.484-.735.485-1.176V11.666a1.68 1.68 0 0 0-.485-1.177A1.65 1.65 0 0 0 19.653 10",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M18.414 10H8.345a17.47 17.47 0 0 0-3.128 10.789A17.45 17.45 0 0 0 9.295 31.25h9.12a1.65 1.65 0 0 0 1.166-.49c.31-.312.484-.735.485-1.176V11.666a1.68 1.68 0 0 0-.485-1.177A1.65 1.65 0 0 0 18.414 10",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C43E1C",
  d: "M1.894 10h16.52c.439 0 .859.176 1.169.488.31.313.483.736.483 1.178v16.668c0 .442-.174.866-.483 1.178-.31.312-.73.488-1.168.488H1.894c-.438 0-.858-.176-1.168-.488a1.67 1.67 0 0 1-.484-1.178V11.666c0-.442.174-.866.484-1.178S1.456 10 1.894 10"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F9F7F7",
  d: "M10.15 13.75a5.13 5.13 0 0 1 3.414 1.006 3.626 3.626 0 0 1 1.185 2.914 3.43 3.43 0 0 1-.586 1.985 3.93 3.93 0 0 1-1.666 1.482 5.6 5.6 0 0 1-2.502.53H7.628v4.583h-2.43v-12.5zm-2.523 5.854h2.09c.663.049 1.32-.148 1.849-.555a1.38 1.38 0 0 0 .624-1.283q0-2.073-2.395-2.073H7.627z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "powerpoint_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h40v40H0z"
})))));
export { SvgPowerpoint as ReactComponent };
export default __webpack_public_path__ + "static/media/powerpoint.7869d1a5.svg";